import {Dictionary} from "@reduxjs/toolkit";
import {IOrderProduct} from "../models/OrderModel";
import {formatPrice, getQuantity, getReceiveDiscount} from "./index";
import { roundNumber } from "../modules/common/helper";

const getPriceDetailByAmount: any = (
  products: Dictionary<IOrderProduct>, 
  discountAmount: number, 
  toString = true
) => { 
  
  const arrKey = Object.keys(products);

  let totalTax = 0;
  let totalPrice = 0;
  let totalDiscount = 0;
  let originPrice = 0;
  let originPriceWithVat = 0;

  let totalBeforeDiscount = 0;

  arrKey.forEach((key: string) => {
    const item = products[key];
    const quantity = getQuantity(item);
    const salePrice = item?.price_of_agency?.new_sale_price ?? item?.price_of_agency?.sale_price ?? (item?.price ?? 0);

    totalBeforeDiscount += quantity * salePrice;
  });

  if (totalBeforeDiscount === 0) {
    return {};
  }

  let distributedDiscount = 0;

  arrKey.forEach((key: string, index: number) => {
    const item = products[key];
    const quantity = getQuantity(item);
    let salePrice = item?.price ?? 0;
    let marketPrice = item?.best_supplier?.price_sell ?? salePrice;

    if (item?.price_of_agency) {
      salePrice = item?.price_of_agency?.new_sale_price ?? item?.price_of_agency?.sale_price ?? salePrice;
      marketPrice = item?.price_of_agency?.new_market_price ?? item?.price_of_agency?.market_price ?? marketPrice;
    }
    const vat = item?.new_vat ?? item?.vat ?? 0;
    const itemTotal = salePrice * quantity;

    // @ts-ignore
    const perDiscount = getReceiveDiscount({
      market_price: marketPrice,
      sale_price: salePrice
    });
    const discountFromPrice = (marketPrice / 100) * perDiscount * quantity;

    let itemDiscount = roundNumber((itemTotal / totalBeforeDiscount) * discountAmount);

    if (index === arrKey.length - 1) {
      itemDiscount = discountAmount - distributedDiscount;
    }

    distributedDiscount += itemDiscount;

    const unitDiscount = itemDiscount / quantity;
    const unitPrice = salePrice - unitDiscount;
    const itemAmount = unitPrice * quantity;

    totalTax += itemAmount * vat / 100;
    totalPrice += itemAmount;
    
    totalDiscount += (itemDiscount + discountFromPrice);

    originPrice += quantity * salePrice;
    originPriceWithVat += quantity * (salePrice + salePrice * vat / 100);
  });
  return {
    price: toString ? formatPrice(totalPrice) : totalPrice,
    tax: toString ? formatPrice(totalTax) : totalTax,
    discount: toString ? formatPrice(totalDiscount) : totalDiscount,
    withOutTax: toString ? formatPrice(totalPrice) : totalPrice,
    taxInc: toString ? formatPrice(totalPrice + totalTax) : totalPrice + totalTax,
    originPrice: toString ? formatPrice(originPrice) : originPrice,
    originPriceWithVat: toString ? formatPrice(originPriceWithVat) : originPriceWithVat
  };
};

export default getPriceDetailByAmount;